import { TagToken } from 'tag/ts/smart_tag/model/enums/TagToken';
import { ITagConstants } from 'tag/ts/tag/interfaces/model/ITagConstants';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Current Tag constants
 */
export class TagConstants implements ITagConstants {

	private static _instance: ITagConstants = new TagConstants();

	constructor() {
		if ( TagConstants._instance ) {
			throw new Error( this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()' );
		}
		TagConstants._instance = this;
	}

	get name(): string {
		return 'TagConstants';
	}

	/**
	 * @description Default DAI IU values
	 * @return {{desktop: string, mobile: string}}
	 */
	get DAI_IU(): { desktop: string, mobile: string } {
		return {
			desktop: '/8264/vaw-can/desktop/' + TagToken.PARTNER_ID,
			mobile: '/8264/vaw-can/mobile_web/' + TagToken.PARTNER_ID + '_mobile'
		};
	}

	/**
	 * @description AdOps specific values
	 * @returns {{CMSID: number}}
	 */
	get ADOPS_ID() {
		return {
			CMSID: 2497752
		};
	}

	/**
	 * @description WARNING: VOD DAI SDK SETUP: Flag enabling DAI SDK+ VOD setup
	 * @see {@link https://jira.cbsi.com/browse/CBSVIDEO-5246}
	 * @see {@link https://jira.cbsi.com/browse/CBSVIDEO-5260}
	 * @returns {boolean}
	 */
	get DAI_SDK_VOD_ENABLED() {
		return true;
	}

	public static getInstance(): ITagConstants {
		return TagConstants._instance;
	}

}